/**
 * useApiClient Hook
 * Stellt Zugriff auf den API Client zur Verfügung
 */

import { useCallback } from "react";
import { apiClient } from "../services/apiClient";

export const useApiClient = () => {
  return useCallback(() => apiClient, [])();
};

export default useApiClient;
